export interface SiteFooterData {
  titleKey: string;
  links: SiteFooterLinkData[];
}

export interface SiteFooterLinkData {
  textKey: string;
  href: string;
}

const siteFooterData: SiteFooterData[] = [
  {
    titleKey: 'shopGear',
    links: [
      {
        textKey: 'categories',
        href: '/gear-categories',
      },
      {
        textKey: 'brands',
        href: '/brands',
      },
      {
        textKey: 'shops',
        href: '/shops',
      },
      {
        textKey: 'deals',
        href: '/promo/deals-and-steals',
      },
      {
        textKey: 'priceDrops',
        href: '/promo/price-drops',
      },
      {
        textKey: 'financing',
        href: '/promo/financing',
      },
      {
        textKey: 'new',
        href: '/promo/top-sellers-recent-releases',
      },
      {
        textKey: 'handpicked',
        href: '/page/handpicked-collections',
      },
    ],
  },
  {
    titleKey: 'resources',
    links: [
      {
        textKey: 'news',
        href: '/news',
      },
      {
        textKey: 'priceGuide',
        href: '/price-guide',
      },
      {
        textKey: 'buyingGuide',
        href: '/guide',
      },
      {
        textKey: 'giftCards',
        href: '/gift-cards ',
      },
      {
        textKey: 'refer',
        href: 'refer-a-friend',
      },
    ],
  },
  {
    titleKey: 'sell',
    links: [
      {
        textKey: 'sellerHub',
        href: '/selling',
      },
      {
        textKey: 'reverbPayments',
        href: '/selling/reverb-payment-faq',
      },
    ],
  },
  {
    titleKey: 'company',
    links: [
      {
        textKey: 'about',
        href: '/page/about',
      },
      {
        textKey: 'careers',
        href: '/page/jobs',
      },
      {
        textKey: 'press',
        href: '/page/press',
      },
      {
        textKey: 'reverbGives',
        href: '/page/reverb-gives',
      },
    ],
  },
  {
    titleKey: 'help',
    links: [
      {
        textKey: 'helpCenter',
        href: 'https://help.reverb.com/hc/en-us',
      },
      {
        textKey: 'reverbProtection',
        href: '/page/reverb-protection',
      },
      {
        textKey: 'mobileApps',
        href: '/page/reverb-app',
      },
      {
        textKey: 'integrations',
        href: '/page/integrations',
      },
      {
        textKey: 'affiliate',
        href: '/selling/how-to-join-the-reverb-affiliate-program',
      },
      {
        textKey: 'appStore',
        href: '/apps',
      },
    ],
  },
];

export default siteFooterData;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/site_footer_data.ts